import ServiceLandingPage from "../../ServiceLandingPage/ServiceLandingPage";

const corporateTrainingService = {
  layout: "person-content",
  image: "/service-corporate-language-cultural-training.png",
  heroPosition: "center",
  heroContentSx: { pt: { xs: 3, md: 10 } },
  hideContentCta: true,
  simpleContact: true,
  personInRequest: true,
  hideMainContent: true,
  defaultRequestExpanded: true,
  person: {
    image: "/team-erik-lutz.jpeg",
    link: "/team",
  },
  translations: {
    de: {
      heroLabel: "Sprach- und interkulturelles Training für Unternehmen",
      title: "Damit deine internationalen Mitarbeitenden in Deutschland wirklich ankommen",
      description: "Wir bereiten deine neuen Kolleg:innen praxisnah auf die deutsche Arbeitskultur vor – für reibungslose Kommunikation vom ersten Tag an.",
      cta: "Kontakt aufnehmen",
      sectionTitle: "Der Dozent",
      person: { name: "Erik Lutz", role: "Dozent für Sprachtraining & interkulturelle Kommunikation" },
      body: [
        "Master in Sprach- und interkultureller Kommunikationswissenschaft",
        "Zertifizierter TELC-Prüfer",
        "6 Jahre Erfahrung – von Universitäten bis zu Führungsetagen",
        "Begleitet Fach- und Führungskräfte auf allen Niveaus, von A1 bis C2",
        "Spezialisiert auf Kommunikation im Berufsalltag.",
      ],
      whyTitle: "Warum mit uns?",
      whyParagraphs: ["Neue Mitarbeitende aus dem Ausland bringen oft exzellente fachliche Qualifikationen mit – aber die ungeschriebenen Regeln der deutschen Arbeitskultur lassen sich nicht einfach ablesen. Genau diese Themen tauchen in gemischten Teams am häufigsten auf:"],
      screeningTitle: "Typische Herausforderungen im Arbeitsalltag",
      screeningItems: [
        "Feedback-Kultur: Direktes Feedback wird als Kritik oder unhöflich empfunden – oder umgekehrt, zu vorsichtiges Feedback kommt gar nicht an.",
        "Pünktlichkeit und Zeitplanung: Unterschiedliche Vorstellungen davon, was pünktlich oder flexibel bedeutet.",
        "Hierarchie und Eigeninitiative: Manche Mitarbeitende warten auf klare Anweisungen, wo eigenständiges Handeln erwartet wird – oder umgekehrt.",
        "Kommunikationsstil in Meetings: Zurückhaltung, die eigene Meinung offen zu äußern, aus Respekt vor Vorgesetzten oder aus Unsicherheit.",
        "Trennung von Beruflichem und Privatem: Andere Erwartungen an Smalltalk, Nähe und Distanz im Arbeitsalltag.",
        "Umgang mit Regeln und Prozessen: Deutschlands stark regelgeleitete Arbeitsweise kann verunsichern, wenn man anderes gewohnt ist.",
        "Sprachbarrieren jenseits der Grammatik: Fachjargon, Abkürzungen und ungeschriebene Kommunikationsnormen im Team.",
      ],
      whyDetail: "Unser Training ist bewusst interaktiv aufgebaut. Wir sprechen nicht abstrakt über Kulturunterschiede, sondern gehen gezielt auf die Standpunkte, konkreten Situationen, Konfrontationen und Herausforderungen ein, die deine Mitarbeitenden im Arbeitsalltag tatsächlich erleben. So wird aus Missverständnissen echtes Verständnis – mit weniger Reibung, schnellerer Integration und einem Team, das von Anfang an gut zusammenarbeitet.",
      benefitsTitle: "",
      benefitItems: [],
      processTitle: "So funktioniert es",
      processSteps: [
        { title: "Kurzes Gespräch", text: "Erzähl uns, was dir bei deinem Team aufgefallen ist oder wo ihr Unterstützung braucht. Unser bestehendes Trainingskonzept passen wir maßgeschneidert an dein Team an." },
        { title: "Individuelle Workshop-Reihe", text: "Wir stellen mehrere aufeinander aufbauende Termine zusammen, abgestimmt auf Sprachniveau und Berufsfeld deiner Mitarbeitenden." },
        { title: "Praxisnahes Training", text: "Reale Arbeitssituationen, Kommunikation im Team, Meetings und Feedbackgespräche – alles mit direktem Alltagsbezug." },
        { title: "Laufende Rückmeldung", text: "Du erfährst, welche Fortschritte deine Mitarbeitenden machen und wo sie zusätzliche Unterstützung brauchen." },
      ],
      processClosing: "",
      requestTitle: "Kontakt",
      requestIntro: "Schreib uns kurz, worum es bei deinem Team geht. Wir melden uns zeitnah und schlagen dir drei passende Termine für ein Erstgespräch vor.",
      requestSubmit: "Kontakt aufnehmen",
      requestDirect: "Lieber direkt sprechen? Ruf uns an:",
      requestWrite: "oder schreib uns:",
    },
    en: {
      heroLabel: "Language and intercultural training for companies",
      title: "Help your international employees truly settle into working life in Germany",
      description: "We prepare your new colleagues for German workplace culture through practical training, enabling smooth communication from day one.",
      cta: "Get in touch",
      sectionTitle: "Your trainer",
      person: { name: "Erik Lutz", role: "Trainer for language and intercultural communication" },
      body: [
        "Master’s degree in Language and Intercultural Communication Studies",
        "Certified TELC examiner",
        "6 years of experience, from universities to executive teams",
        "Supports specialists and managers at every level, from A1 to C2",
        "Specialized in everyday workplace communication.",
      ],
      whyTitle: "Why work with us?",
      whyParagraphs: ["International employees often bring excellent professional qualifications, but the unwritten rules of German workplace culture are not easy to learn from a handbook. These are the topics that most often cause friction in diverse teams:"],
      screeningTitle: "Common workplace challenges",
      screeningItems: [
        "Feedback culture: Direct feedback may feel personal or impolite, while overly cautious feedback may fail to communicate the real message.",
        "Punctuality and planning: People can have very different ideas about what punctual and flexible mean.",
        "Hierarchy and initiative: Some employees wait for clear instructions when independent action is expected, or the reverse.",
        "Communication in meetings: Employees may hesitate to express an opinion out of respect for managers or uncertainty.",
        "Work and private life: Expectations around small talk, closeness and professional boundaries differ.",
        "Rules and processes: Germany’s process-oriented workplace culture can feel unfamiliar or restrictive.",
        "Language beyond grammar: Technical terminology, abbreviations and unwritten team communication norms create additional barriers.",
      ],
      whyDetail: "Our training is intentionally interactive. Instead of discussing cultural differences only in theory, we work with the real situations, viewpoints, conflicts and challenges your employees experience every day. Misunderstandings become genuine understanding, integration becomes faster, and the team collaborates effectively from the start.",
      benefitsTitle: "",
      benefitItems: [],
      processTitle: "How it works",
      processSteps: [
        { title: "Short consultation", text: "Tell us what you have noticed in your team and where support is needed. We tailor our existing training concept to your team." },
        { title: "Custom workshop series", text: "We create a sequence of connected sessions suited to your employees’ language level and professional field." },
        { title: "Practical training", text: "Real workplace situations, team communication, meetings and feedback conversations with direct everyday relevance." },
        { title: "Ongoing feedback", text: "You receive updates on your employees’ progress and where further support may be useful." },
      ],
      processClosing: "",
      requestTitle: "Contact",
      requestIntro: "Tell us briefly about your team and its challenges. We will get back to you promptly and suggest three suitable times for an initial consultation.",
      requestSubmit: "Get in touch",
      requestDirect: "Prefer to speak directly? Call us:",
      requestWrite: "or email us:",
    },
    ar: {
      heroLabel: "تدريب لغوي وتواصل بين الثقافات للشركات",
      title: "علشان موظفينك الأجانب يندمجوا فعلًا في بيئة العمل في ألمانيا",
      description: "بنجهّز موظفينك الجدد عمليًا على طبيعة وثقافة الشغل في ألمانيا، علشان التواصل يبقى أسهل والتعاون ينجح من أول يوم.",
      cta: "تواصل معانا",
      sectionTitle: "المحاضر",
      person: { name: "Erik Lutz", role: "مدرّب لغة ومتخصص في التواصل بين الثقافات" },
      body: [
        "ماجستير في علوم اللغة والتواصل بين الثقافات",
        "ممتحن TELC معتمد",
        "أكثر من 6 سنوات خبرة، من الجامعات لحد تدريب المديرين",
        "درّب متخصصين ومديرين على جميع المستويات من A1 إلى C2",
        "متخصص في التواصل داخل بيئة العمل.",
      ],
      whyTitle: "ليه معانا؟",
      whyParagraphs: ["الموظفين الجدد اللي بييجوا من برّه ألمانيا بيكون عندهم في الغالب مؤهلات وخبرات ممتازة، لكن فيه حاجات كتير في ثقافة الشغل الألمانية مش بتكون مكتوبة في أي دليل. ودي أكتر المواقف اللي بتسبب سوء تفاهم داخل فرق العمل:"],
      screeningTitle: "تحديات شائعة في بيئة العمل",
      screeningItems: [
        "ثقافة الـ Feedback: الفيدباك المباشر ممكن يتفهم على إنه انتقاد شخصي، ولو كان حذر زيادة ممكن الرسالة الأساسية ما توصلش.",
        "الالتزام بالمواعيد وتنظيم الوقت: كل شخص عنده تصور مختلف لمعنى الالتزام بالمواعيد أو المرونة.",
        "التسلسل الإداري والمبادرة الشخصية: في موظفين بيستنوا تعليمات واضحة بينما بيكون متوقع منهم ياخدوا المبادرة بنفسهم، وأحيانًا العكس.",
        "أسلوب التواصل في الاجتماعات: في ناس بتتردد تعبّر عن رأيها بصراحة احترامًا للمدير أو بسبب عدم الثقة بالنفس.",
        "الفصل بين الشغل والحياة الشخصية: التوقعات بتختلف بخصوص الـ Small Talk وحدود العلاقة بين الزملاء.",
        "التعامل مع القوانين والإجراءات: الالتزام بالقواعد والإجراءات في ألمانيا ممكن يكون جديد أو غريب على بعض الموظفين.",
        "اللغة مش مجرد قواعد: المصطلحات المهنية والاختصارات وطريقة التواصل غير المكتوبة داخل الفريق بتعمل تحديات إضافية.",
      ],
      whyDetail: "تدريبنا تفاعلي بالكامل. إحنا مش بنتكلم عن الاختلافات الثقافية بشكل نظري، لكن بنناقش المواقف الحقيقية والآراء والتحديات اللي موظفينك بيعيشوها كل يوم في الشغل. والنتيجة إن سوء التفاهم بيقل، والتفاهم الحقيقي بيزيد، والاندماج بيكون أسرع، والفريق يشتغل مع بعض من البداية بشكل أفضل.",
      benefitsTitle: "",
      benefitItems: [],
      processTitle: "الخطوات",
      processSteps: [
        { title: "مكالمة قصيرة", text: "احكيلنا إيه اللي لاحظته في فريقك أو فين محتاجين دعم، وإحنا هنعدّل برنامجنا بحيث يناسب احتياجات فريقك." },
        { title: "سلسلة ورش عمل مخصصة", text: "بنجهز مجموعة ورش مترتبة على بعض حسب مستوى اللغة وطبيعة شغل الموظفين." },
        { title: "تدريب عملي", text: "مواقف حقيقية من بيئة العمل واجتماعات وتواصل داخل الفريق ومحادثات الـ Feedback." },
        { title: "متابعة مستمرة", text: "هنطلعك باستمرار على التقدم اللي بيحققه موظفينك والجوانب اللي محتاجة دعم إضافي." },
      ],
      processClosing: "",
      requestTitle: "تواصل معانا",
      requestIntro: "ابعتلنا باختصار طبيعة فريقك أو التحديات اللي بتواجهكم، وإحنا هنتواصل معاك في أقرب وقت ونقترح عليك 3 مواعيد مناسبة لميتنج مبدئي.",
      requestSubmit: "تواصل معانا",
      requestDirect: "تفضل تتكلم معانا مباشرة؟ اتصل بنا:",
      requestWrite: "أو راسلنا:",
    },
  },
};

const CorporateTrainingPage = () => <ServiceLandingPage service={corporateTrainingService} />;

export default CorporateTrainingPage;
